@if (isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()">
  </div>
}


@if (!isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()">
  </div>
}